<template>
  <section v-if="fighter" :class=getFighterClassName>
    <FighterHero :fighter=fighter />
    <FighterAbilities class="section-blue section-padding" :fighter=fighter />
    <FighterProfile :fighter=fighter class="section-padding section-fighter-profile" />
    <section class="fighter-grid section-blue section-padding">
      <div class="container">
        <Title title="fighters" size="large" color="cream" type="fighters" :translate=true direction="anti-clockwise" />
        <FightersGrid class="fighter-view" />
      </div>
    </section>
  </section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

import Title from '@/components/ui/Title';
import FightersGrid from '@/components/ui/fighters/FightersGrid';
import FighterHero from '@/components/ui/fighters/FighterHero';
import FighterAbilities from '@/components/ui/fighters/FighterAbilities';
import FighterProfile from '@/components/ui/fighters/FighterProfile';


export default {
  name: 'FightersView',
  props: ['slug'],
  components: {
    Title,
    FightersGrid,
    FighterHero,
    FighterAbilities,
    FighterProfile
  },
  data() {
    return {
      hasFighters: false
    }
  },
  created() {
    if(this.fighters.length == 0) {
      this.getFighters().then(() => {
        this.hasFighters = true;
      });
    } else {
      this.hasFighters = true;
    }
  },
  computed: {
    ...mapGetters({
      fighters: 'fighters'
    }),
    fighter() {
      if(!this.hasFighters) return false;
      let fighter = false;

      fighter = this.fighters.find(f => f.slug === this.slug);

      if(fighter == undefined) {
        this.$router.push({ name: 'error' });
      }

      return fighter;
    },
    getFighterClassName() {
      if(this.fighter.fighter_class) {
        let fighterName = this.fighter.fighter_class.toLowerCase();
        fighterName = fighterName.replace(' ', '-');
        return `fighter-${fighterName}`;
      }
    }
  },
  methods: {
    ...mapActions({
      getFighter: 'getFighter',
      getFighters: 'getFighters'
    })
  }
};
</script>

<style lang="scss">
  .fighter-grid {
    padding: 8vw 0;
    .fighters-grid {
     // padding-top: 40px;
      @include bp($bp--m) {
      //  padding-top: 0;
      }
    }

    @include bp($bp--m) {
      //padding: 8vw 0;
      .title {
        display: none;
      }
    }
    @include bp($max-width) {
      padding: 105px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/FightersView.vue